import React, { Fragment } from "react";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
import { useFormData } from "../../../../hooks/client/use-form-data";
const FormBuilderFormInterfaceThumbScale = ({ item, analyticForm, t }) => {
  if (!item) return null;
  const { formDataSetters, formData } = useFormData();
  const elements = item.elements;
  const { input, legend } = FormBuilderElementsMappingService.getSingleElementHTMLTags(item);
  const onFocus = () => {
    analyticForm == null ? void 0 : analyticForm.trackInputFocused(input.name);
  };
  const onBlur = () => analyticForm == null ? void 0 : analyticForm.trackInputBlurred(input.name);
  return /* @__PURE__ */ React.createElement("fieldset", { className: item.class }, /* @__PURE__ */ React.createElement("legend", null, t(legend == null ? void 0 : legend.nodeValue)), elements.filter((el) => (el == null ? void 0 : el.type) === "radio").map((input2, index) => {
    var _a;
    const labelNodeValue = (_a = elements.find((label) => (label == null ? void 0 : label.for) === (input2 == null ? void 0 : input2.id))) == null ? void 0 : _a.nodeValue;
    const defaultChecked = (formData == null ? void 0 : formData[input2.name]) === input2.value;
    return /* @__PURE__ */ React.createElement(Fragment, { key: index }, /* @__PURE__ */ React.createElement("label", { htmlFor: input2 == null ? void 0 : input2.id }, t(labelNodeValue), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: input2 == null ? void 0 : input2.type,
        name: input2 == null ? void 0 : input2.name,
        id: input2 == null ? void 0 : input2.id,
        onFocus,
        onBlur,
        onChange: (e) => formDataSetters.setInputValue(input2.name, e.target.checked ? e.target.value : void 0),
        defaultChecked,
        value: input2.value,
        required: input2 == null ? void 0 : input2.required
      }
    )));
  }));
};
FormBuilderFormInterfaceThumbScale.displayName = "FormBuilderFormInterfaceThumbScale";
export default React.memo(FormBuilderFormInterfaceThumbScale);
